import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './download-tender-mobile-app.component';
import { KeywordsSectionModule } from 'src/app/modules/tenders/_components/keywords-section/keywords-section.module';
import { FormsModule } from '@angular/forms';

const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent
  }
];

@NgModule({
  declarations: [LandingPageComponent],
  imports: [CommonModule, FormsModule, RouterModule.forChild(routes), KeywordsSectionModule]
})
export class LandingPageModule { }
